export default "__VITE_ASSET__CnBPqqhF__"